module.exports = __webpack_public_path__ + "static/media/YF39_0.7ea628c9.jpg";